import { addItem, removeItem } from "./actions";
import purchaseInProcessStore from "./store";

export const addVideoPurchase = (payload) =>
  purchaseInProcessStore.dispatch(addItem(payload));

export const removeVideoPurchase = (payload) =>
  purchaseInProcessStore.dispatch(removeItem());
